export default __webpack_public_path__ + "static/media/logoKaspar.0bedbaa8.png";